import { create } from '@bufbuild/protobuf'
import { skipToken, useQuery } from '@connectrpc/connect-query'
import { getBidImportStatus } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'
import { GetBidImportStatusRequestSchema } from '@ebalance/proto/bffuser/v1/bidding_spot_service_pb'

import { toProtoDate } from '~/models/dateTime'

export function useBidImportStatus(
  targetDate: Date,
  intraday: boolean,
  options: { enabled?: boolean } = {},
): boolean {
  const { data } = useQuery(
    getBidImportStatus,
    options.enabled === false
      ? skipToken
      : create(GetBidImportStatusRequestSchema, {
          targetDate: toProtoDate(targetDate),
          intraday,
        }),
    {
      refetchInterval: 60_000,
      throwOnError: false,
    },
  )
  return data?.hasUnimportedBids ?? false
}
